<template>
    <div class="ls-non-mowing__container">
        <form @submit.prevent="submitNowMowingForm">
            <ls-panel class="ls-border-all ls-border-bottom-none">
                <LsOrderServiceLead ref="orderServiceLead">
                    <a
                        class="ls-button ls-button--yellow"
                        style="width: 75px;"
                        @click.prevent="goBack"
                    >
                        <i class="fa fa-arrow-circle-left"></i>
                        <span>&nbsp;Back</span>
                    </a>
                    <h2
                        class="ls-align--center ls-condensed"
                        :class="{ 'ls-margin--bottom ls-margin--top': screenSize.xs }"
                    >
                        Request a Quote for Specialty Services
                    </h2>
                    <p class="ls-align--center" data-font-size="-1" style="margin-top: 3px;">
                        <span>We'll be in touch via phone or email</span>
                    </p>
                    <hr />
                </LsOrderServiceLead>
            </ls-panel>

            <ls-panel class="ls-border-all ls-border-top-none">
                <ls-contact-info :title="'How can we get in touch?'"></ls-contact-info>
                <ls-error></ls-error>

                <div slot="button" class="grid">
                    <div class="grid__col-12 ls-margin--top">
                        <button
                            v-ls-track.click="{
                                target: 'non-mowing-form--submit-button',
                            }"
                            class="ls-button ls-button--block ls-button--lg ls-button--yellow ls-margin--top"
                            type="submit"
                        >
                            <span v-if="orderServiceLead.loadingStatus.isUpdating"
                                ><i class="fa fa-pulse fa-spinner"></i>&nbsp;Requesting Quote</span
                            >
                            <span v-else>Request Quote</span>
                        </button>
                    </div>
                </div>
            </ls-panel>
        </form>
    </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
import { mapState, mapGetters, mapActions } from 'vuex';
import {
    SCREEN_SIZE__GET_MOBILE_SCREEN,
    SCREEN_SIZE__GET_DESKTOP_SCREEN,
    ORDER_SERVICE_LEAD__SUBMIT,
} from '@/store/types';
import eventBusService from '@/services/event-bus.service';
import lsPanel from '@/components/original-mydot/panel/Panel.vue';
import LsOrderServiceLead from '@/components/original-mydot/order-service-lead/OrderServiceLead.vue';
import lsContactInfo from '@/components/original-mydot/contact-info/ContactInfo.vue';
import lsError from '@/components/original-mydot/error/Error.vue';

export default {
    components: {
        lsPanel,
        LsOrderServiceLead,
        lsContactInfo,
        lsError,
    },
    computed: {
        ...mapState(['orderServiceLead', 'screenSize', 'contactInfo']),
        ...mapGetters({
            mobile: SCREEN_SIZE__GET_MOBILE_SCREEN,
            desktop: SCREEN_SIZE__GET_DESKTOP_SCREEN,
        }),
        allStatesValid() {
            return this.$refs.orderServiceLead.checkFormValidation() && this.contactInfo.valid;
        },
    },
    methods: {
        ...mapActions({
            submit: ORDER_SERVICE_LEAD__SUBMIT,
        }),
        submitNowMowingForm() {
            if (!this.allStatesValid) {
                eventBusService.eventBus.$emit('submitButtonClick');
                setTimeout(() => {
                    let firstInvalidInput = null;
                    const orderServiceLeadFirstElement = document.getElementsByClassName(
                        'ls-order-service-lead--invalid'
                    )[0];
                    const lsInvalidFirstElement = document.getElementsByClassName('ls-invalid')[0];

                    // because we have a mix of both classes on the orderServiceLead component, we'll need to detect which is higher on the page if both have an invalid item
                    if (orderServiceLeadFirstElement) {
                        if (lsInvalidFirstElement) {
                            firstInvalidInput =
                                orderServiceLeadFirstElement.getBoundingClientRect().top <
                                lsInvalidFirstElement.getBoundingClientRect().top
                                    ? orderServiceLeadFirstElement
                                    : lsInvalidFirstElement;
                        } else {
                            firstInvalidInput = orderServiceLeadFirstElement;
                        }
                    } else {
                        firstInvalidInput = lsInvalidFirstElement;
                    }

                    if (firstInvalidInput) {
                        const offset = this.screenSize.xs || this.screenSize.sm ? -150 : -105; // offset to account for the sticky header + the input label
                        VueScrollTo.scrollTo(firstInvalidInput, 500, { offset });
                    }
                });
            } else {
                this.submit();
            }
        },
        goBack() {
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-non-mowing__container {
    margin-bottom: 100px; // scrolling to make bottom not feel like its getting cut off
}
</style>
